module.exports = __webpack_public_path__ + "img/p3.f1a1ba36.png";